// extracted by mini-css-extract-plugin
export var background = "o3EBP";
export var contentWrapper = "gGmXW";
export var image = "IVeAC";
export var playButton = "iCMGE";
export var root = "tm1mW";
export var title = "_9gllz";
export var wave = "rII08";